














import { Icon } from '@alpha/ink'
import icoLookup from '@/utilities/ico-lookup'
import { thumbnail } from '@/utilities/asset-helpers'
import * as graph from '@shared/types/graphql'
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  components: {
    Icon
  }
})
export default class ExistingAsset extends Vue {
  @Prop() asset!: graph.Prototype
  @Prop({ default: false }) selected!: boolean
  get thumbnail () {
    return thumbnail(this.asset)
  }

  get imageTypeMap () {
    return icoLookup
  }
}
